module.exports = __webpack_public_path__ + "static/media/country_lk.a0ce221b.webp";